import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import DashboardCrm from "../views/DashboardCrm";

//AuthenticationInner pages
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";
import BasicSignUp from "../pages/AuthenticationInner/Register/BasicSignUp";
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from "../pages/AuthenticationInner/PasswordReset/BasicPasswReset";

import CoverPasswReset from "../pages/AuthenticationInner/PasswordReset/CoverPasswReset";
import BasicLockScreen from "../pages/AuthenticationInner/LockScreen/BasicLockScr";
import CoverLockScreen from "../pages/AuthenticationInner/LockScreen/CoverLockScr";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import BasicSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg";
import CoverSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg";
import BasicTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify";
import CoverTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import ResetPassword from "../pages/AuthenticationInner/ResetPassword";
import ResetSuccessful from "../pages/AuthenticationInner/ResetPassword/ResetSuccessful";
import RegisterSuccessful from "../pages/AuthenticationInner/Register/RegisterSuccessful";
import Products from "../pages/Products/index";
import Privacy from "../views/DashboardCrm/FooterPages/Privacy";
import RefundPolicy from "../views/DashboardCrm/FooterPages/RefundPolicy";
import PricingDetails from "../views/DashboardCrm/FooterPages/PricingDetails";
import PaymentSuccess from "../views/Payment/PaymentSuccess";
import PaymentFailure from "../views/Payment/PaymentFailure";
import AboutUs from "../views/DashboardCrm/FooterPages/AboutUs";
import ContactUs from "../views/DashboardCrm/FooterPages/ContactUs";
import Terms from "../views/DashboardCrm/FooterPages/Terms";
import ViewDetails from "../views/DashboardCrm/ViewDetails";
import ConfirmPayment from "../views/DashboardCrm/ConfirmPayment";
import ViewHistory from "../views/DashboardCrm/ViewHistory";
import DailyTransactions from "../views/DashboardCrm/DailyTransactions";
import UploadData from "../views/DashboardCrm/UploadData";
import ServiceLogs from "../views/DashboardCrm/ServiceLogs";

const authProtectedRoutes = [
  { path: "/daily_transactions", component: DailyTransactions },
  { path: "/servicelogs", component: ServiceLogs },
  { path: "/upload_data", component: UploadData },

  // {
  //   path: "/",
  //   exact: true,
  //   component: () => <Redirect to="/login" />,
  // },
];

const publicRoutes = [
  { path: "/dashboard", component: DashboardCrm },
  { path: "/Products", component: Products },

  // Authentication Page
  { path: "/logout", component: Logout },
  { path: "/privacy", component: Privacy },
  { path: "/refund_policy", component: RefundPolicy },
  { path: "/pricing_details", component: PricingDetails },
  { path: "/payment_success", component: PaymentSuccess },
  { path: "/payment_failure", component: PaymentFailure },
  { path: "/about_us", component: AboutUs },
  { path: "/contact_us", component: ContactUs },
  { path: "/terms", component: Terms },
  { path: "/view_details/:id", component: ViewDetails },
  { path: "/confirm_payment", component: ConfirmPayment },
  { path: "/view_history", component: ViewHistory },

  { path: "/login", component: CoverSignIn },
  { path: "/reset-password", component: ResetPassword },
  { path: "/reset-password-successful", component: ResetSuccessful },
  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/register", component: Register },

  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: BasicSignIn },
  { path: "/auth-signin-cover", component: CoverSignIn },
  { path: "/auth-signup-basic", component: BasicSignUp },
  { path: "/auth-signup-cover", component: CoverSignUp },
  { path: "/register-successful", component: RegisterSuccessful },
  { path: "/auth-pass-reset-basic", component: BasicPasswReset },
  { path: "/auth-pass-reset-cover", component: CoverPasswReset },
  { path: "/auth-lockscreen-basic", component: BasicLockScreen },
  { path: "/auth-lockscreen-cover", component: CoverLockScreen },
  { path: "/auth-logout-basic", component: BasicLogout },
  { path: "/auth-logout-cover", component: CoverLogout },
  { path: "/auth-success-msg-basic", component: BasicSuccessMsg },
  { path: "/auth-success-msg-cover", component: CoverSuccessMsg },
  { path: "/auth-twostep-basic", component: BasicTwosVerify },
  { path: "/auth-twostep-cover", component: CoverTwosVerify },
  { path: "/auth-404-basic", component: Basic404 },
  { path: "/auth-404-cover", component: Cover404 },
  { path: "/auth-404-alt", component: Alt404 },
  { path: "/auth-500", component: Error500 },

  { path: "/auth-pass-change-basic", component: BasicPasswCreate },
  { path: "/auth-pass-change-cover", component: CoverPasswCreate },
  { path: "/auth-offline", component: Offlinepage },
  {
    path: "*",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
];

export { authProtectedRoutes, publicRoutes };
